<template>
  <div id="app">
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <p>检查是否支持webRTC</p>
    <ul>
      <li v-for="(item, idx) in rtcAPIs" :key="idx">{{item.name}} - {{item.isSupport}}</li>
    </ul>
    <hr>
    <p>检查麦克风</p>
    麦克风音量: <progress :value="audioLevel" max="100"></progress> - <span>功能是否成功：{{micPhoneOk}}</span>
    <br>
    <hr>
    <p>检查扬声器</p>
    <button @click="speakerWorksWell">听得到</button> <button @click="speakerWorksBad">听不到</button>
    <audio id="sampleMusic" controls="controls">
      <source src="https://smallclass.teameeting.cn/static/mp3/music.mp3" type="audio/mp3">
      Your browser does not support the audio tag.
    </audio>
    <br>
     <span>功能是否成功：{{speakerOk}}</span>
    <hr>
    <p>检查分辨率</p>
    <ul>
      <li v-for="(item, idx) in profiles" :key="idx">{{item.width}}x{{item.height}} - {{item.status}}</li>
    </ul>
    <hr>
  </div>
</template>

<script>
import detect from '@/assets/ar-detect/detect';

export default {
  name: 'app',
  components: {
    // HelloWorld
  },
  data() {
    return {
      steps: [

      ],

      audioLevel: 0,
      maxAudioLevel: 0,
      micPhoneOk: false,

      speakerOk: false,

      rtcAPIs: [
        {
          name: 'GetUserMedia',
          isSupport: false,
        },
        {
          name: 'DataChannel',
          isSupport: false,
        },
        {
          name: 'RTCPeerConnection',
          isSupport: false,
        },
      ],
      profiles: [
        {
          width: 160,
          height: 120,
          status: '',//none pendding support no-support
        },
        {
          width: 120,
          height: 120,
          status: '',//none pendding support no-support
        },
        //180P
        {
          width: 320,
          height: 180,
          status: '',//none pendding support no-support
        },
        {
          width: 180,
          height: 180,
          status: '',//none pendding support no-support
        },
        {
          width: 240,
          height: 180,
          status: '',//none pendding support no-support
        },
        //240P
        {
          width: 320,
          height: 240,
          status: '',//none pendding support no-support
        },
        {
          width: 240,
          height: 240,
          status: '',//none pendding support no-support
        },
        {
          width: 424,
          height: 240,
          status: '',//none pendding support no-support
        },
        //360P
        {
          width: 640,
          height: 360,
          status: '',//none pendding support no-support
        },
        {
          width: 360,
          height: 360,
          status: '',//none pendding support no-support
        },
        {
          width: 480,
          height: 360,
          status: '',//none pendding support no-support
        },
        //480P
        {
          width: 640,
          height: 480,
          status: '',//none pendding support no-support
        },
        {
          width: 480,
          height: 480,
          status: '',//none pendding support no-support
        },
        {
          width: 848,
          height: 480,
          status: '',//none pendding support no-support
        },
        //720P
        {
          width: 960,
          height: 720,
          status: '',//none pendding support no-support
        },
        {
          width: 1280,
          height: 720,
          status: '',//none pendding support no-support
        },
        //1080P
        {
          width: 1920,
          height: 1080,
          status: '',//none pendding support no-support
        }
      ]
    }
  },
  mounted() {
    console.log(detect, detect.DataChannelSupport);
    this.checkRTCSupport()
    .then(this.detectMicPhone)
    .then(()=>{
      
    });

    // this.checkProfiles();
  },
  methods: {
    //检查浏览器是否支持webRTC
    checkRTCSupport() {
      return new Promise((resolve, reject) => {
        this.rtcAPIs[0].isSupport = detect.GetUserMediaSupport;
        this.rtcAPIs[1].isSupport = detect.DataChannelSupport;
        this.rtcAPIs[2].isSupport = detect.PeerConnectionSupport;
        resolve();
      })
    },
    //检查麦克风是否正常
    detectMicPhone() {
      return new Promise((resolve, reject) => {
        detect.getLocalAudioVolume().then(()=>{
          let timer = setInterval(()=>{
            let audioLevel = detect.getAudioLevel();
            this.audioLevel = audioLevel;
            (audioLevel > this.maxAudioLevel) && (this.maxAudioLevel = audioLevel);
          }, 30);
          setTimeout(()=>{
            if (this.maxAudioLevel > 0) {
              this.detectSpeaker();
              clearInterval(timer);
              this.audioLevel = 0;
              this.maxAudioLevel = 0;
              this.micPhoneOk = true;
              resolve();
            } else{
              reject();
            }
          }, 6e3);
        })
      });
    },
    //扬声器正常
    speakerWorksWell() {
      this.checkProfiles();
    },
    //扬声器不正常
    speakerWorksBad() {
      this.checkProfiles();
    },
    detectSpeaker() {
      
    },
    //检查分辨率
    async checkProfiles() {
      for (let item in this.profiles) {
        this.profiles[item].status = 'pendding';
        await detect.checkResolution(this.profiles[item]).then(isSupport => {
          this.profiles[item].status = isSupport;
        }).catch(err => {
          console.log(err);
        });
      }
    }
  },
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
